import React from 'react';
import { useIntl } from "react-intl";
import { TabContent, TabPane, Table } from "reactstrap";
import { toCSV, toXLSX } from '../../../utils/exportUtils';
import { ExportButton } from "../../components/ui/ExportButton/ExportButton";
export default function MetricsTables(props) {
    var intl = useIntl();
    return React.createElement(TabContent, { activeTab: props.activeTab },
        props.chartsData.map(function (datasets, index) {
            var headersAndRows = dataSetsToArray(datasets, intl);
            return React.createElement(TabPane, { key: datasets[0].name + '_' + index, tabId: index },
                React.createElement(Table, { className: "table-sm table-responsive mt-3" },
                    React.createElement("thead", null,
                        React.createElement("tr", null, headersAndRows.headers.map(function (value) {
                            return React.createElement("th", null, value);
                        }))),
                    React.createElement("tbody", null, headersAndRows.rows.map(function (columns, index) {
                        return React.createElement("tr", { key: datasets[0].name + '' + index }, columns.map(function (value) {
                            return React.createElement("td", null, value);
                        }));
                    }))));
        }),
        React.createElement("div", { className: "d-flex justify-content-end" },
            React.createElement(ExportButton, { onClick: function (event, type) {
                    var headersAndRows = dataSetsToArray(props.chartsData[props.activeTab], intl);
                    switch (type) {
                        case 'xlsx':
                            toXLSX([headersAndRows.headers].concat(headersAndRows.rows), props.chartsData[props.activeTab].title);
                            break;
                        case 'csv':
                            toCSV([headersAndRows.headers].concat(headersAndRows.rows), props.chartsData[props.activeTab].title);
                            break;
                    }
                } })));
}
function dataSetsToArray(datasets, intl) {
    var headers = ['timestamps'].concat(datasets.map(function (dataset) { return dataset.label; }));
    var dates = {};
    datasets.forEach(function (dataset) { return dataset.data.forEach(function (sample) {
        if (!!dates[sample.x] === false) {
            dates[sample.x] = [];
        }
        dates[sample.x].push(sample.y);
    }); });
    var rows = Object.keys(dates).map(function (timestamp) {
        return [intl.formatDate(parseInt(timestamp))].concat(dates[timestamp]);
    });
    return { headers: headers, rows: rows };
}
